import React from 'react';
import { Stack } from '@mui/material';
import { useTheme, withStyles } from '@material-ui/core';
import VTypography from '../../VTypography/VTypography';
import styles from './styles';

const VAutocompleteOption = ({
  classes,
  option,
  searchQuery,
  onSelectOption,
  setIsLoadingOption,
  CustomComponent,
}) => {
  const theme = useTheme();
  const handleClick = () => {
    setIsLoadingOption(true);
    onSelectOption(option);
    setIsLoadingOption(false);
  };

  const { label } = option;
  const matches = label.toLowerCase().indexOf(searchQuery.toLowerCase());
  const beforeMatch = label.substring(0, matches);
  const matchText = label.substring(matches, matches + searchQuery.length);
  const afterMatch = label.substring(matches + searchQuery.length);

  if (CustomComponent) {
    return (
      <CustomComponent
        matches={[beforeMatch, matchText, afterMatch]}
        option={option}
        searchQuery={searchQuery}
        onClick={handleClick}
      />
    );
  }

  return (
    <Stack className={classes.optionBox} direction="row" alignItems="center" onClick={handleClick}>
      <VTypography component="span" color={theme.palette.text.primary}>
        {beforeMatch}
        <strong>{matchText}</strong>
        {afterMatch}
      </VTypography>
    </Stack>
  );
};

export default withStyles(styles)(VAutocompleteOption);
